import { SpellCheckTextbox } from './SpellCheckTextbox';
import { FEATURES, isFeatureEnabled } from '~src/features';

/**
 * Converts all fabric.Textbox objects on the canvas to SpellCheckTextbox objects
 * This ensures backward compatibility with saved projects
 * @param {fabric.Canvas} canvas - The fabric canvas instance
 */
export async function convertTextboxesToSpellCheck(canvas) {
  if (!canvas) {
    return;
  }

  // Check if spellcheck feature is enabled
  const allowSpellcheck = await isFeatureEnabled(FEATURES.SPELLCHECK);
  if (!allowSpellcheck) {
    return;
  }

  const objects = canvas.getObjects();
  const textboxes = objects.filter(
    (obj) => obj.type === 'textbox' && !(obj instanceof SpellCheckTextbox)
  );

  textboxes.forEach((textbox) => {
    // Get the index of the textbox in the canvas
    const index = objects.indexOf(textbox);

    // Convert to SpellCheckTextbox
    const spellCheckTextbox = SpellCheckTextbox.fromTextbox(textbox);

    // Remove the old textbox and add the new one at the same position
    canvas.remove(textbox);
    canvas.insertAt(spellCheckTextbox, index);
  });

  // Request render if any conversions were made
  if (textboxes.length > 0) {
    canvas.requestRenderAll();
  }
}
